import { I18n } from '@app/i18n/strings-keys';
import {
  TRANSFER_STATUS_NAME,
  TRANSFER_STATUS_VALUE,
} from '@shared/types/enums/transfer-status.enum';

export enum TRANSFER_TYPE {
  PRE_EVENT_TRANSFER = 'pre',
  DURING_EVENT_TRANSFER = 'during',
  OUTSIDE_OF_EVENT_TRANSFER = 'outside',
}

export type TRANSFER_TYPE_VALUE =
  | TRANSFER_TYPE.PRE_EVENT_TRANSFER
  | TRANSFER_TYPE.DURING_EVENT_TRANSFER
  | TRANSFER_TYPE.OUTSIDE_OF_EVENT_TRANSFER;

export enum TRANSFER_PRINT_TYPE {
  PRINT_TYPE_EMPTY = 'empty_quantity_received',
}

export enum TRANSFER_SAVE_OPERATION {
  SAVE = 'save',
  SAVE_AND_SUBMIT = 'saveAndSubmit',
}

export enum REPLENISH_TYPE_VALUES {
  PAR = 'par_qty',
  MIN = 'min_qty',
  MAX = 'max_qty',
  ENDING_COUNT_OR_EXPECTED_QTY = 'ENDING_COUNT_OR_EXPECTED_QTY',
  QOH = 'QOH',
}

export enum REPLENISH_TYPE_NAMES {
  PAR = 'PAR',
  MIN_QTY = 'Minimum Quantity',
  MIN = 'Minimum',
}

export const REPLENISH_NAME_OPTIONS = {
  PAR: I18n.Common.PAR,
  MIN_QTY: I18n.Common.MINQty,
  MIN: I18n.Common.Minimum,
};

export const TRANSFER_TYPE_ENUM_OPTIONS = Object.freeze({
  [TRANSFER_TYPE.PRE_EVENT_TRANSFER]: I18n.Forms.TransferForm.PreEventHyphen,
  [TRANSFER_TYPE.DURING_EVENT_TRANSFER]: I18n.Forms.TransferForm.DuringEvent,
  [TRANSFER_TYPE.OUTSIDE_OF_EVENT_TRANSFER]:
    I18n.Forms.TransferForm.OutsideofEvent,
});

export const TRANSFER_STATUS_ENUM_OPTIONS = Object.freeze({
  [TRANSFER_STATUS_VALUE.New]: I18n.Status.New,
  [TRANSFER_STATUS_VALUE.Open]: I18n.Status.Open,
  [TRANSFER_STATUS_VALUE.Pending]: I18n.Status.Pending,
  [TRANSFER_STATUS_VALUE.Rejected]: I18n.Status.Rejected,
  [TRANSFER_STATUS_VALUE.Completed]: I18n.Status.Completed,
  [TRANSFER_STATUS_VALUE.Null]: I18n.Status.NoStatusBrackets,
  [TRANSFER_STATUS_VALUE.Canceled]: I18n.Status.Canceled,
  [TRANSFER_STATUS_VALUE.Void]: I18n.Status.Void,
});

export const TRANSFER_DESTINATIONS_STATUS_OPTIONS = [
  {
    text: I18n.Status.New,
    value: TRANSFER_STATUS_NAME.New,
  },
  {
    text: I18n.Status.NoStatusBrackets,
    value: TRANSFER_STATUS_VALUE.Null,
  },
];

export const enum DUPLICATE_TRANSFER_ERROR_KEY {
  ITEM_NOT_ASSIGN_SITE = 'item_not_assign_site',
  ITEM_NOT_EXIST = 'item_not_exist',
  ITEM_TRANSFER_UNIT_NOT_EXIST = 'item_transfer_unit_not_exist',
}

export const TRANSFER_FILTER_STATUS_OPTIONS = [
  {
    text: TRANSFER_TYPE_ENUM_OPTIONS[TRANSFER_TYPE.PRE_EVENT_TRANSFER],
    value: TRANSFER_TYPE.PRE_EVENT_TRANSFER,
  },
  {
    text: TRANSFER_TYPE_ENUM_OPTIONS[TRANSFER_TYPE.DURING_EVENT_TRANSFER],
    value: TRANSFER_TYPE.DURING_EVENT_TRANSFER,
  },
  {
    text: TRANSFER_TYPE_ENUM_OPTIONS[TRANSFER_TYPE.OUTSIDE_OF_EVENT_TRANSFER],
    value: TRANSFER_TYPE.OUTSIDE_OF_EVENT_TRANSFER,
  },
];
